/**
 * This has more information than a FormStepDTO on the server. We are mapping FormControlsDTOs into this, for
 * return from the render form method.
 *
 * Created by rjulius on 2/19/16.
 */
import Model from "common/framework/Model";
import NestedData from "common/framework/NestedData";
import PromptModel from "common/models/PromptInputModel";
import PromptInputType from "common/enums/PromptInputType";
export default Model.define({
    init: function(options) {
        var config = $.extend({}, options);
        if (config.controls == undefined || !config.controls.length) {
            config.controls = [];
        }
        Model.fn.init.apply(this, arguments);

        this.initLocalData();
        this.setLocalData();
    },
    id: "id",
    fields: {
        id: {
            type: "string",
            editable: false,
            defaultValue: null
        },
        name: {
            type: "string"
        },
        ordinal: {
            type: "number"
        },
        formId: {
            type: "string"
        },
        controls: {},
        // client-side check for whether this step has at least one button, in order to submit it
        hasButtons: {
            transient: true,
            type: "boolean"
        }
    },

    toJSON: function() {
        var base = Model.fn.toJSON.apply(this, arguments);

        base.controls = this.controlsDS.localData();
        delete base.controlsDS;

        return base;
    },
    setLocalData: function() {
        this.controlsDS.localData(this.controls || []);
        this.controlsDS.read();

        var btn = false,
            me = this;
        $.each(this.controlsDS.data(), function(i, val) {
            // popupate hasButtons
            if (val.inputType == PromptInputType.BUTTON) {
                btn = true;
            }
            // reset path to include full contextual servlet URL for images
            if (val.inputType == PromptInputType.IMAGE) {
                val.imageName = context.path + "/servlet/form/image/?image" + (val.imageId ? "Id=" + val.imageId :
                    "Name=" + val.imageName + "&formId=" + me.formId);
            }
        });
        // popupate hasButtons
        this.set("hasButtons", btn);
    },

    accept: function() {
        var res = Model.fn.accept.apply(this, arguments);

        this.setLocalData();
        return res;
    },

    initLocalData: function() {
        kendo.data.ObservableObject.fn.set.call(this, "controlsDS", new NestedData({
            schema: {
                model: PromptModel
            }
        }));

    }
})